export const kintoneErrorMessage = {
    notRegisteredTenantSetting: 'kinotone連携が無効もしくは有効な設定値が入力されていません。管理者に設定項目「kintoneテナントを環境に設定する(管理者設定)」の実施を依頼してください',
    failedToIssueToken: 'kintoneとの連携に失敗しました。ネットワーク状況をご確認ください',
};